import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { DayUseHandler } from '@libs/util-services';

/**
 * Implementação concreta do `DAY_USE_HANDLER` da calendar-lib (provido na rota
 * `/agenda`).
 *
 * <p>A lib não conhece as rotas do app: ela sabe que existe um dia de day use e
 * chama este handler. Centro esportivo sem o módulo não registra o provider, e o
 * card cai no comportamento de sempre — é o que dispensa espalhar
 * `if (temModulo)` pela agenda.
 */
@Injectable({ providedIn: 'root' })
export class LessorDayUseHandler implements DayUseHandler {
  private readonly router = inject(Router);

  async open(dayUseDateId: number, date?: string): Promise<void> {
    await this.router.navigate(['/dayuse/dates', dayUseDateId], {
      // A data volta como query para o "voltar" da tela do dia devolver o gestor
      // ao mesmo dia da agenda, e não ao hoje.
      queryParams: date ? { returnDate: date } : {},
    });
  }
}
